const link = document.createElement('link');
link.rel = 'stylesheet';
link.href = 'https://cdnjs.cloudflare.com/ajax/libs/cropperjs/1.5.1/cropper.min.css';
document.getElementsByTagName('head')[0].appendChild(link);
